document.addEventListener('DOMContentLoaded', function () {

    const morse_converter = {
        'a': '.- ', 'b': '-... ', 'c': '-.-. ', 'd': '-.. ', 'e': '. ',
        'f': '..-. ', 'g': '--. ', 'h': '.... ', 'i': '.. ', 'j': '.--- ',
        'k': '-.- ', 'l': '.-.. ', 'm': '-- ', 'n': '-. ', 'o': '--- ',
        'p': '.--. ', 'q': '--.- ', 'r': '.-. ', 's': '... ', 't': '- ',
        'u': '..- ', 'v': '...- ', 'w': '.-- ', 'x': '-..- ', 'y': '-.-- ',
        'z': '--.. ', '1': '.---- ', '2': '..--- ', '3': '...-- ', '4': '....- ',
        '5': '..... ', '6': '-.... ', '7': '--... ', '8': '---.. ', '9': '----. ',
        '0': '----- ', '.': '.-.-.- ', ',': '--..-- ', '?': '..--.. ',
        "'": '.----. ', '!': '-.-.-- ', '/': '-..-. ', '(': '-.--. ',
        ')': '-.--.- ', '&': '.-... ', ':': '---... ', ';': '-.-.-. ',
        '=': '-...- ', '+': '.-.-. ', '-': '-....- ', '_': '..--.- ',
        '"': '.-..-. ', '$': '...-..- ', '@': '.--.-. ', ' ': '/'
    };

    let engravingType = null;
    let engravingFont = null;
    let parentVariantId = null;

    const variantPopup    = document.querySelector('.variant-popup-customization');
    const popupButton     = document.querySelector('.product-popup-button-wrapper button');
    const closeBtn        = document.querySelector('.variant-popup-header .close-btn');
    const goBackBtn       = document.querySelector('.variant-popup-header .go-back-btn');
    const morseCodeInput  = document.querySelector('#morse-code-engraving-input');
    const morseCodeTransl = document.querySelector('#morse-code-translation');
    const rotatingSpan    = document.querySelector('.popular-engravings span');

    const rotatingCopy = [
        "our initials (JFK)",
        "The date you met (03.03.2003)",
        "Children's names (Sarah)",
        "Your nickname for each other (Peanut)",
        "My ♡ is yours",
        "You complete me"
    ];
    let rotatingInterval = null;

    // ── Morse live translation ───────────────────────────────────
    if (morseCodeInput && morseCodeTransl) {
        morseCodeInput.addEventListener('keyup', function () {
            let out = '';
            for (let i = 0; i < morseCodeInput.value.length; i++) {
                out += morse_converter[morseCodeInput.value.charAt(i).toLowerCase()] || '';
            }
            morseCodeTransl.value = out;
        });
    }

    // ── Rotating copy ────────────────────────────────────────────
    function startRotatingCopy() {
        if (!rotatingSpan) return;
        let idx = 0;
        rotatingSpan.textContent = rotatingCopy[0];
        if (rotatingInterval) clearInterval(rotatingInterval);
        rotatingInterval = setInterval(function () {
            idx = (idx + 1) % rotatingCopy.length;
            rotatingSpan.textContent = rotatingCopy[idx];
        }, 2000);
    }

    // ── Helpers ──────────────────────────────────────────────────
    function removeActiveClass(selector) {
        document.querySelectorAll(selector).forEach(el => el.classList.remove('active'));
    }

    function handleStepCount(currentStep, totalStep) {
        const cur = document.querySelector('.variant-popup-header .current-step');
        const tot = document.querySelector('.variant-popup-header .total-steps');
        if (cur) cur.textContent = currentStep;
        if (tot && totalStep) tot.textContent = totalStep;
    }

    function resetPopup() {
        if (variantPopup) variantPopup.classList.remove('active');
        document.body.style.overflow = 'unset';
        removeActiveClass('.variant-popup-body-item');
        const first = document.querySelectorAll('.variant-popup-body-item')[0];
        if (first) first.classList.add('active');
        handleStepCount(1);
        if (rotatingInterval) clearInterval(rotatingInterval);
    }

    // ── Auto-select defaults ──────────────────────────────────────
    // Default to data-value="NO" (No Gift Box) because that is Shopify's
    // first_available_variant on this product and avoids a mismatch on open.
    // Falls back to whatever the first block is if NO isn't found.
    function autoSelectDefaults() {
        document.querySelectorAll('.select-product-finish-wrapper').forEach(wrapper => {
            if (!wrapper.querySelector('.select-stone-block.active, .product-option-block.active')) {
                // Prefer NO (default variant) → fall back to first block
                const defaultBlock = wrapper.querySelector('.select-stone-block[data-value="NO"]')
                                  || wrapper.querySelector('.select-stone-block')
                                  || wrapper.querySelector('.product-option-block');
                if (defaultBlock) defaultBlock.classList.add('active');
            }
        });

        document.querySelectorAll('.select-product-engraving-wrapper').forEach(wrapper => {
            if (!wrapper.querySelector('.product-option-block.active')) {
                const first = wrapper.querySelector('.product-option-block');
                if (first) first.classList.add('active');
            }
        });
    }

    // ── Build variant title ───────────────────────────────────────
    // Reads data-value from the active block in each option wrapper.
    // For this gift box product the only wrapper is .select-product-finish-wrapper
    // so result is just "YES" or "NO" — Shopify's exact variant title format.
    function buildVariantTitle() {
        const parts = [];

        document.querySelectorAll('.select-product-finish-wrapper').forEach(wrapper => {
            const active = wrapper.querySelector('.select-stone-block.active')
                        || wrapper.querySelector('.product-option-block.active');
            if (active && active.dataset.value) {
                parts.push(active.dataset.value.trim());
            }
        });

        document.querySelectorAll('.select-product-engraving-wrapper').forEach(wrapper => {
            const active = wrapper.querySelector('.product-option-block.active');
            if (active && active.dataset.value) {
                parts.push(active.dataset.value.trim());
            }
        });

        return parts.join(' / ');
    }

    // ── Fetch variant and update Add-to-cart button ───────────────
    function fetchVariantDetails(variantTitle) {
        const addBtn = document.querySelector('.select-stone-add-btn button');
        if (!addBtn) return false;

        console.log('[Popup] Looking up variant:', JSON.stringify(variantTitle));

        const allVariantEls = document.querySelectorAll('.hidden-variant-item');

        // 1. Exact match
        let variantEl = document.querySelector(
            `.hidden-variant-item[data-variant-title="${variantTitle}"]`
        );

        // 2. Case-insensitive match
        if (!variantEl && variantTitle) {
            const lower = variantTitle.toLowerCase();
            allVariantEls.forEach(el => {
                if (!variantEl && el.dataset.variantTitle &&
                    el.dataset.variantTitle.toLowerCase() === lower) {
                    variantEl = el;
                }
            });
            if (variantEl) console.log('[Popup] Matched via case-insensitive fallback');
        }

        // 3. Single-variant product — use it directly
        if (!variantEl && allVariantEls.length === 1) {
            variantEl = allVariantEls[0];
            console.log('[Popup] Single variant — using it directly');
        }

        // 4. The CRO script (CC058) swaps YES/NO label text but the underlying
        //    Shopify variant title may literally be "Default Title" on simple
        //    products, or the add-on checkbox state determines the variant.
        //    Fallback: read the variant ID directly from the main Shopify
        //    product form's selected variant input and match by ID.
        if (!variantEl) {
            const shopifySelectedId = document.querySelector(
                '[name="id"], #product-select, .product-variant-id'
            );
            if (shopifySelectedId && shopifySelectedId.value) {
                allVariantEls.forEach(el => {
                    if (!variantEl && el.dataset.variantId === shopifySelectedId.value) {
                        variantEl = el;
                    }
                });
                if (variantEl) console.log('[Popup] Matched via Shopify selected variant ID fallback');
            }
        }

        // 5. Last resort: use whichever hidden variant is marked available
        if (!variantEl) {
            allVariantEls.forEach(el => {
                if (!variantEl && el.dataset.variantAvailable === 'true') {
                    variantEl = el;
                }
            });
            if (variantEl) console.log('[Popup] Matched via first-available fallback');
        }

        if (!variantEl) {
            console.warn('[Popup] No variant matched. Title tried:', JSON.stringify(variantTitle));
            console.warn('[Popup] Available titles:');
            allVariantEls.forEach(el =>
                console.log('  >', JSON.stringify(el.dataset.variantTitle), '| available:', el.dataset.variantAvailable)
            );
            addBtn.textContent = 'Unavailable';
            addBtn.setAttribute('disabled', true);
            parentVariantId = null;
            return false;
        }

        parentVariantId = variantEl.dataset.variantId;
        const available = variantEl.dataset.variantAvailable === 'true';
        const price     = variantEl.dataset.variantPrice;

        console.log('[Popup] Matched variant:', parentVariantId, '| available:', available, '| price:', price);

        if (available) {
            addBtn.innerHTML = 'Add to cart -&nbsp;' + price;
            addBtn.removeAttribute('disabled');
        } else {
            addBtn.textContent = 'Sold Out';
            addBtn.setAttribute('disabled', true);
        }

        return true;
    }

    function handleVariantChange() {
        fetchVariantDetails(buildVariantTitle());
    }

    // ── Open popup ───────────────────────────────────────────────
    if (popupButton) {
        popupButton.addEventListener('click', function () {
            if (variantPopup) variantPopup.classList.add('active');
            document.body.style.overflow = 'hidden';
            startRotatingCopy();
            autoSelectDefaults();
            handleVariantChange();
        });
    }

    // ── Close ────────────────────────────────────────────────────
    if (closeBtn) {
        closeBtn.addEventListener('click', resetPopup);
    }

    // ── Go back ──────────────────────────────────────────────────
    if (goBackBtn) {
        goBackBtn.addEventListener('click', function () {
            const activeItem = document.querySelector('.variant-popup-body-item.active');
            if (!activeItem) return;
            const currentStep = parseInt(activeItem.dataset.currentStep);

            if (currentStep === 1) {
                resetPopup();
            } else {
                activeItem.classList.remove('active');
                const prevStep = (engravingType === 'Morse Code' && currentStep === 4)
                    ? currentStep - 2
                    : currentStep - 1;
                const prevItem = document.querySelector(`[data-current-step="${prevStep}"]`);
                if (prevItem) prevItem.classList.add('active');
                handleStepCount(prevStep);
            }
        });
    }

    // ── Step handlers ─────────────────────────────────────────────

    function handleEngravingType(selector) {
        selector.querySelectorAll('.engraving-type-item-block').forEach(block => {
            block.addEventListener('click', function () {
                const currentStep = parseInt(selector.dataset.currentStep);
                engravingType = block.dataset.type;

                removeActiveClass('.engraving-type-item-block');
                block.classList.add('active');
                selector.classList.remove('active');

                const next = document.querySelector(`[data-current-step="${currentStep + 1}"]`);
                if (next) next.classList.add('active');

                removeActiveClass('.add-engraving-input-container');
                const container = document.querySelector(`[data-engraving-type="${engravingType}"]`);
                if (container) container.classList.add('active');

                const fontWrapper  = document.querySelector('.engraving-font-item-wrapper');
                const imageWrapper = document.querySelector('.add-engraving-wrapper .image-wrapper');
                if (fontWrapper)  fontWrapper.style.display  = (engravingType === 'Morse Code')  ? 'none' : 'block';
                if (imageWrapper) imageWrapper.style.display = (engravingType === 'Coordinates') ? 'none' : 'block';

                handleStepCount(currentStep + 1, 3);
            });
        });
    }

    function handleAddEngraving(selector) {
        const addEngravingButton = selector.querySelector('.add-engraving-next-btn button');
        if (addEngravingButton) {
            addEngravingButton.addEventListener('click', function () {
                const currentStep = parseInt(selector.dataset.currentStep);
                selector.classList.remove('active');
                const next = document.querySelector(`[data-current-step="${currentStep + 1}"]`);
                if (next) next.classList.add('active');
                handleStepCount(currentStep + 1);
            });
        }

        function syncInput(popupId, actualId) {
            const popupEl  = document.querySelector(popupId);
            const actualEl = document.getElementById(actualId);
            if (!popupEl || !actualEl) return;
            popupEl.addEventListener('change', function () {
                actualEl.value = popupEl.value;
                actualEl.dispatchEvent(new Event('change'));
            });
        }

        syncInput('#popup-year',  'year');
        syncInput('#popup-month', 'month');
        syncInput('#popup-day',   'day');

        function syncCheckbox(popupSelector, actualId) {
            const popupEl  = document.querySelector(popupSelector);
            const actualEl = document.getElementById(actualId);
            if (!popupEl || !actualEl) return;
            popupEl.addEventListener('change', function () {
                actualEl.checked = popupEl.checked;
                actualEl.dispatchEvent(new Event('change'));
            });
        }

        syncCheckbox('.variant-popup-customization .map-const-setting-popup input', 'constellations-lines');
        syncCheckbox('.variant-popup-customization .map-grid-setting-popup input',  'lines-graticule-show');
    }

    function handleSelectEngravingFont(selector) {
        selector.querySelectorAll('.engraving-font-item-block').forEach(block => {
            block.addEventListener('click', function () {
                removeActiveClass('.engraving-font-item-block');
                block.classList.add('active');
                engravingFont = block.dataset.font;
            });
        });
    }

    function handleSelectStone(selector) {
        autoSelectDefaults();

        // Gift box YES/NO toggle
        selector.querySelectorAll('.select-stone-block').forEach(block => {
            block.addEventListener('click', function () {
                block.closest('.select-product-finish-wrapper')
                    .querySelectorAll('.select-stone-block')
                    .forEach(b => b.classList.remove('active'));
                block.classList.add('active');

                // Sync the add-on checkbox that the CRO script (CC058) also watches.
                // CC058 listens on .ProductForm__Option--addons li clicks and toggles
                // #product-add-on-checkbox — we mirror that here so both UIs stay in sync.
                const addOnCheckbox = document.getElementById('product-add-on-checkbox');
                if (addOnCheckbox) {
                    const shouldBeChecked = block.dataset.value === 'YES';
                    if (addOnCheckbox.checked !== shouldBeChecked) {
                        addOnCheckbox.click(); // use click() to trigger CC058's listeners too
                    }
                }

                handleVariantChange();
            });
        });

        // Finish option clicks
        selector.querySelectorAll('.select-finish-block').forEach(block => {
            block.addEventListener('click', function () {
                block.closest('.select-product-finish-wrapper')
                    .querySelectorAll('.select-finish-block')
                    .forEach(b => b.classList.remove('active'));
                block.classList.add('active');
                handleVariantChange();
            });
        });

        // Engraving-count / other option clicks
        selector.querySelectorAll('.select-engraving-block').forEach(block => {
            block.addEventListener('click', function () {
                block.closest('.select-product-engraving-wrapper')
                    .querySelectorAll('.select-engraving-block')
                    .forEach(b => b.classList.remove('active'));
                block.classList.add('active');
                handleVariantChange();
            });
        });

        // Add to cart — delegates to #starmap-complete
        const addBtn = selector.querySelector('.select-stone-add-btn button');
        if (addBtn) {
            addBtn.addEventListener('click', function () {
                const starmapComplete = document.getElementById('starmap-complete');
                if (starmapComplete) {
                    starmapComplete.click();
                } else {
                    console.error('[Popup] #starmap-complete button not found in DOM');
                }
            });
        }

        handleVariantChange();
    }

    // ── Wire up all steps ─────────────────────────────────────────
    document.querySelectorAll('.variant-popup-body-item').forEach(item => {
        const type = item.dataset.type;
        if (type === 'select-engraving-type') handleEngravingType(item);
        if (type === 'add-engraving') {
            handleAddEngraving(item);
            handleSelectEngravingFont(item);
        }
        if (type === 'select-stone') handleSelectStone(item);
    });

});